import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoUp from '../assets/images/logo-up.png';
import WhatsAppIcon from './WhatsAppIcon';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // This hook provides the current location

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when the location changes (user navigates to another page)
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className="bg-white text-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
          {/* Responsive Logo */}
          <img
            src={logoUp}
            className="w-24 md:w-40 lg:w-24" // Adjust the width at different breakpoints
            alt="ADSKI Logo"
          />
        </Link>
        <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
          <Link to="tel:6394731250">
            <button
              type="button"
              className="text-white bg-gray-800 hover:bg-gray-900 rounded-lg text-sm px-4 py-2 text-center"
            >
              +91 6394731250
            </button>
          </Link>
          <button
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            onClick={toggleMenu} // Toggle the menu on click
          >
            <span className="sr-only">Open main menu</span>
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
            </svg>
          </button>
        </div>
        {/* Menu section */}
        <div className={`items-center justify-between w-full md:flex md:w-auto md:order-1 ${isMenuOpen ? 'block' : 'hidden'}`} id="navbar-sticky">
          <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white">
            <li>
              <Link to="/" className="homeLink text-gray-900 hover:text-blue-600" aria-current="page">Home</Link>
            </li>
            <li>
              <Link to="/about" className="homeLink text-gray-900 hover:text-blue-600">About</Link>
            </li>
            <li>
              <Link to="services" className="homeLink text-gray-900 hover:text-blue-600">Services</Link>
            </li>
            <li>
              <Link to="/contact" className="homeLink text-gray-900 hover:text-blue-600">Contact</Link>
            </li>
            <li>
              <Link to="/plans" className="homeLink text-gray-900 hover:text-blue-600">Plans</Link>
            </li>
          </ul>
        </div>
      </div>
      <WhatsAppIcon/>
    </nav>
  );
};

export default Navbar;
